import { useState } from 'react';

import { UseFormReturn } from 'react-hook-form';
import { IChannelRecording } from 'components/ProgramSetupChannelSettings';
import { IProgram } from 'shared/interfaces/IProgram';
import { IProgramSetup, IProgramSetupForm } from 'shared/interfaces/IProgramSetup';
import { ProgramSetupContainer } from './ProgramSetup.styled';
import {
  ProgramSetupPageSearchLoading,
  ProgramSetupPageSearchOptions,
  ProgramSetupSearch,
} from './ProgramSetupContainer';
import { ProgramSetupDetails, ProgramSetupAnchors } from './ProgramSetupDetails';
import { ProgramSetupTimeslot } from './ProgramSetupTimeslot';
import { ErrorBanner } from './components/ErrorBanner';
import { StepRail, Step } from './components/StepRail';

interface Props {
  form: UseFormReturn<IProgramSetupForm, object>;
  programSetup?: IProgramSetup;
  options: ProgramSetupPageSearchOptions;
  searchLoading: ProgramSetupPageSearchLoading;
  onSearch: (key: keyof ProgramSetupSearch, value: any) => void;
  isLoading?: boolean;
  inheritedRecording?: IChannelRecording;
  program?: IProgram;
}

// Recording config now lives at channel level (Channel Settings on the list), so the rail is
// Program → Anchors → Schedule.
const STEPS: Step[] = [
  { id: 'secDetails', label: 'Program' },
  { id: 'secAnchors', label: 'Anchors' },
  { id: 'secSchedule', label: 'Schedule' },
];

export const ProgramSetupView = ({
  form,
  options,
  searchLoading,
  onSearch,
  isLoading,
  programSetup,
  inheritedRecording,
  program,
}: Props) => {
  const { formState } = form;
  const [activeStep, setActiveStep] = useState<string>(STEPS[0].id);

  const goToStep = (id: string) => {
    setActiveStep(id);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const sharedProps = { form, options, searchLoading, onSearch, isLoading, programSetup };

  return (
    <ProgramSetupContainer className="ps-redesign">
      <StepRail steps={STEPS} active={activeStep} onGo={goToStep} />

      <ErrorBanner errors={formState.errors} />

      <ProgramSetupDetails {...sharedProps} inheritedRecording={inheritedRecording} program={program} />
      <ProgramSetupAnchors {...sharedProps} />
      <ProgramSetupTimeslot form={form} isLoading={isLoading} />
    </ProgramSetupContainer>
  );
};
